module.exports = __webpack_public_path__ + "img/6.9ac602e0.png";